export function ConfidenceBadge({ score }: { score: number | null }) {
  if (score === null) return null;
  const pct = Math.round(score * 100);
  const color =
    pct >= 90
      ? "#2f9e44"
      : pct >= 70
        ? "#e67700"
        : pct >= 50
          ? "#d9480f"
          : "#c92a2a";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 4,
        fontSize: 12,
        fontWeight: 700,
        background: color + "22",
        color,
        border: `1px solid ${color}44`,
      }}
    >
      {pct}% confidence
    </span>
  );
}
